import { PeopleSdk } from 'lib-klab-sdks';
import { EmployeeScheduleAssignment } from '../../../domain/models/people/employee-schedule-assignment.model';

const DAY_LABELS: Record<string, string> = {
    MONDAY: 'lun',
    TUESDAY: 'mar',
    WEDNESDAY: 'mié',
    THURSDAY: 'jue',
    FRIDAY: 'vie',
    SATURDAY: 'sáb',
    SUNDAY: 'dom',
};

export function formatWorkDaysSummary(
    workDays: PeopleSdk.WorkDayObject[] | undefined
): { dias: string; inicio: string; fin: string } {
    if (!workDays?.length) {
        return { dias: '-', inicio: '--:--', fin: '--:--' };
    }

    const sorted = [...workDays].sort((a, b) => {
        const order = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
        return order.indexOf(a.dayOfWeek ?? '') - order.indexOf(b.dayOfWeek ?? '');
    });

    const dias = sorted
        .map((d) => DAY_LABELS[String(d.dayOfWeek ?? '').toUpperCase()] ?? String(d.dayOfWeek ?? '').toLowerCase().slice(0, 3))
        .filter(Boolean)
        .join(', ') || '-';

    const first = sorted[0];
    const last = sorted[sorted.length - 1];
    const inicio = first?.startTime ?? '--:--';
    const fin = last?.endTime ?? '--:--';

    return { dias, inicio, fin };
}

export function mapEmployeeListResponseToAssignment(
    emp: PeopleSdk.EmployeeListResponse,
    options?: { timezone?: string; workDaysSummary?: { dias: string; inicio: string; fin: string } }
): EmployeeScheduleAssignment {
    const summary = options?.workDaysSummary ?? { dias: '-', inicio: '--:--', fin: '--:--' };
    const scheduleName = emp.schedule?.name ?? '-';
    const horaLocal =
        String(options?.timezone ?? emp.timezone ?? '')
            .trim() || '-';

    const scheduleId = emp.schedule?.scheduleId != null ? String(emp.schedule.scheduleId) : undefined;

    const dep = emp.department as { departmentId?: number; id?: number } | undefined;
    const loc = emp.location as { locationId?: number; id?: number } | undefined;
    const rol = emp.role as { roleId?: number; id?: number } | undefined;
    const rawDepId = dep && (dep.departmentId != null || dep.id != null) ? Number(dep.departmentId ?? dep.id) : undefined;
    const rawLocId = loc && (loc.locationId != null || loc.id != null) ? Number(loc.locationId ?? loc.id) : undefined;
    const rawRoleId = rol && (rol.roleId != null || rol.id != null) ? Number(rol.roleId ?? rol.id) : undefined;
    const departmentId = rawDepId != null && rawDepId > 0 ? rawDepId : undefined;
    const locationId = rawLocId != null && rawLocId > 0 ? rawLocId : undefined;
    const roleId = rawRoleId != null && rawRoleId > 0 ? rawRoleId : undefined;

    return {
        id: String(emp.employeeId ?? ''),
        employeeId: String(emp.employeeId ?? ''),
        codigo: emp.code ?? '',
        nombres: [emp.name, emp.lastname].filter(Boolean).join(' ').trim() || '-',
        scheduleId,
        horarioAsignado: scheduleName,
        dias: summary.dias,
        inicio: summary.inicio,
        fin: summary.fin,
        horaLocal,
        departmentId,
        locationId,
        roleId,
    };
}

export function mapEmployeeWorkDaysToAssignment(
    workDaysResponse: PeopleSdk.EmployeeWorkDayInternalResponse
): { dias: string; inicio: string; fin: string } {
    return formatWorkDaysSummary(workDaysResponse.workDays);
}
